import { http } from './../../plugins/http/index';
import { getData } from './../get';
import store from "../../store/index";

export const getRuterTimetablesByStopId = async (stopId = 2190400, types='AirportBus,Bus,AirportTrain,Train,Boat,Metro,Tram') =>
{
    const lines = await http.get(`https://reisapi.ruter.no/Line/GetLinesByStopID/${stopId}`).then(getData)

    const data = await http.get(`https://reisapi.ruter.no/StopVisit/GetDepartures/${stopId}?transporttypes=${types}`).then(getData)

    const results = []
    if(data)
        data.forEach(element => {
            const platformNumber = _.get(element,'MonitoredVehicleJourney.MonitoredCall.DeparturePlatformName', 'NotSet')

            if(platformNumber){
                // find platform
                let platform = results.find(p => p.number === platformNumber)

                // if no platform in results - Add new platform
                if(!platform){
                    platform = { number: platformNumber, trains: [] }
                    results.push(platform)
                }
                // Get line id
                const lineId = _.get(element,'MonitoredVehicleJourney.LineRef')
                // Find a train in on platform in results
                let train =  platform.trains.find(p => p.routeId == lineId) // lineId is string

                // if no train in results - Add new train
                if(!train){
                    train = { routeId: lineId, times: [], warnings:[]}
                    platform.trains.push(train)
                }
                // Get vehicle type
                const line = lines.find( l => l.ID == lineId )
                if( line && line.Transportation )
                    train.type = exports.ruterTransportTypes[line.Transportation]

                train.route = _.get(element,'MonitoredVehicleJourney.PublishedLineName', 'NotSet')
                train.destination = _.get(element,'MonitoredVehicleJourney.DestinationName', 'NotSet')
                train.warnings = _.get(element,'Extensions.Deviations', []).map(w => w.Header)

                train.times.push( _.get(element,'MonitoredVehicleJourney.MonitoredCall.ExpectedDepartureTime','') )
            }
        })
    return Promise.resolve(results)
}

export const ruterTransportTypes = {
    0: 'Walking',
    1: 'AirportBus',
    2: 'Bus',
    3: 'Dummy',
    4: 'AirportTrain',
    5: 'Boat',
    6: 'Train',
    7: 'Tram',
    8: 'Metro',
}

export const getEnturTimetablesByStopId = async (stopId = 2190400, types='AirportBus,Bus,AirportTrain,Train,Boat,Metro,Tram') =>
{
    const query = `
       query ConnectionsForStopPlace($id: String!, $departures: Int!) {
        stopPlace(id: $id) {
          id
          name
          estimatedCalls(numberOfDepartures: $departures) {
            aimedDepartureTime
            expectedDepartureTime
            realtime
            forBoarding
            quay {
              id
              publicCode
              description
            }
            serviceJourney {
              id
              journeyPattern {
                line {
                  authority {
                    id
                    name
                  }
                  name
                  publicCode
                  transportMode
                  transportSubmode
                }
              }
            }
            destinationDisplay {
              frontText
            }
            situations {
              situationNumber
              summary {
                value
              }
              description {
                value
              }
              validityPeriod {
                startTime
                endTime
              }
              reportType
            }
            notices {
              text
            }
          }
        }
      }`;
      
    const variables = {
        departures: 100,
        id: `NSR:StopPlace:${stopId}`,
    }

    // https://api.entur.io/journey-planner/v2/graphql
    //TODO: Update journey planner to v3 https://developer.entur.org/pages-journeyplanner-journeyplanner

    const config = {
        'headers': {
            'Et-Client-Name': 'MVG  Kiosk',
            'Content-Type': 'application/json',
        },
    }

    return await http.post('https://api.entur.io/journey-planner/v3/graphql', { query, variables }, config).then(getData)
}

export const getAvinorTimetablesByStopId = async (stopId = 2190400, types='AirportBus,Bus,AirportTrain,Train,Boat,Metro,Tram') =>
{
    const config = {
        'headers': {
            'Content-Type': 'text/xml',
        },
    }
    const data = await http.get(`/terminal/integrations/avinor/${stopId}`, config).then(getData)
    if( data.length )
        return Promise.resolve(data)
}

function fetchResRobotTimetables(stopId) {
    const restRobotApiKey = store.getters.getMapConfigProp('envs.restrobot_api_key') || process.env.VUE_APP_RESROBOT_POST_SCHEDULES_2_API_KEY;
    
    return http.get(`https://api.resrobot.se/v2.1/departureBoard?id=${stopId}&lang=${store.state.activeLocale}&format=json&accessId=${restRobotApiKey}`).then(getData);
}

const TRANSPORT_API_MAP = {
    ruter:  getRuterTimetablesByStopId,
    entur:  getEnturTimetablesByStopId,
    avinor: getAvinorTimetablesByStopId,
    resrobot: fetchResRobotTimetables
}

export {
    TRANSPORT_API_MAP
}